import React, { useCallback } from "react";
import { useParams } from "react-router-dom";
import { APIError } from "../../components/APIError";
import { useNavigator } from "../../components/AppHistory";
import {
  CloseButton,
  CustomDialog,
  Field,
} from "../../components/CustomDialog";
import {
  Box,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import { useWrapUpNoteDetails } from "./hooks/useWrapUpNoteDetails";
import { NoteIcon } from "../../icons";
import { formatDatetime } from "../../utils/formatDate";
import { formatSpacedString } from "../../utils/formatStringSpacing";
import { DialogLoader } from "../../components/Loader";

export const WrapUpNotesDetails: React.FC = () => {
  const { closeOverlay } = useNavigator();
  const { accountNumber, wrapUpNoteId } = useParams();
  const { data: wrapUpNote, error, isLoading } = useWrapUpNoteDetails(
    accountNumber,
    wrapUpNoteId,
  );

  const onCancel = useCallback(() => {
    closeOverlay();
  }, [closeOverlay]);

  return (
    <CustomDialog onClose={onCancel}>
      <DialogTitle>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="no-wrap"
        >
          <Box>
            <Box display="flex" alignItems="center">
              <Box mr={0.5} lineHeight={1}>
                <NoteIcon height={24} width={24} />
              </Box>
              <Typography variant="h6">Wrap-up notes</Typography>
            </Box>
          </Box>
          <Box mr={-1.5}>
            <CloseButton data-testid="WrapUpNotesDetails__Button--close" />
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {error ? (
          <APIError
            title="We can't load details for this wrap-up note at the moment."
            mb={45.5}
          />
        ) : isLoading ? (
          <DialogLoader mb={37} />
        ) : (
          wrapUpNote && (
            <Grid container justify="space-between">
              <Field
                data-testid="Field__Created--value"
                label="Created"
                value={formatDatetime(wrapUpNote.createdDttm)}
              />
              <Field
                data-testid="Field__CreatedBy--value"
                label="Created by"
                value={wrapUpNote.user}
              />
              <Field
                data-testid="Field__Category--value"
                label="Category"
                value={wrapUpNote.category}
              />
              <Field
                data-testid="Field__Subcategory--value"
                label="Subcategory"
                value={wrapUpNote.subcategory}
              />
              <Field
                data-testid="Field__ContactType--value"
                label="Contact type"
                value={wrapUpNote.contactType}
              />
              <Field
                data-testid="Field__Status--value"
                label="Status"
                value={formatSpacedString(wrapUpNote.status)}
              />
              <Field
                data-testid="Field__Summary--value"
                label="Summary"
                fullWidth
                value={wrapUpNote.summary}
                hideEmpty
              />
              <Field
                data-testid="Field__Query--value"
                label="Query"
                fullWidth
                value={wrapUpNote.query}
                hideEmpty
              />
              <Field
                data-testid="Field__Response--value"
                label="Response"
                fullWidth
                value={wrapUpNote.response}
                hideEmpty
              />
            </Grid>
          )
        )}
      </DialogContent>
    </CustomDialog>
  );
};
